import { Link } from 'react-router-dom';
import ScrollReveal from '@/pages/home/components/ScrollReveal';

const days = [
  { day: '周一', en: 'MON', comics: [{ name: '剑影风云', isNew: true }, { name: '机甲纪元' }, { name: '美食奇缘', isNew: true }] },
  { day: '周二', en: 'TUE', comics: [{ name: '星辰之约' }, { name: '暗夜猎手', isNew: true }, { name: '月下怪谈' }] },
  { day: '周三', en: 'WED', comics: [{ name: '异世界领主' }, { name: '青春方程式' }, { name: '甜心食堂', isNew: true }] },
  { day: '周四', en: 'THU', comics: [{ name: '剑影风云' }, { name: '时光信笺', isNew: true }, { name: '妖怪茶馆' }] },
  { day: '周五', en: 'FRI', comics: [{ name: '星辰之约', isNew: true }, { name: '机甲纪元' }, { name: '暗夜猎手' }] },
  { day: '周六', en: 'SAT', comics: [{ name: '异世界领主' }, { name: '美食奇缘' }, { name: '月下怪谈', isNew: true }] },
  { day: '周日', en: 'SUN', comics: [{ name: '青春方程式' }, { name: '时光信笺' }, { name: '甜心食堂' }] },
];

const stats = [
  { value: '7', unit: '天', label: '每周更新' },
  { value: '21', unit: '部', label: '连载新番' },
  { value: '18:00', unit: '', label: '每日准点' },
];

export default function Schedule() {
  return (
    <div className="min-h-screen bg-white pt-20 overflow-hidden">
      {/* ===== 漫画风 Hero ===== */}
      <section className="relative px-4 md:px-8 lg:px-16 xl:px-24 pt-16 md:pt-24 pb-14 md:pb-20">
        {/* 网点背景装饰 */}
        <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-[radial-gradient(circle,rgba(255,107,138,0.10)_1.5px,transparent_1.5px)] [background-size:18px_18px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-[320px] h-[320px] bg-[radial-gradient(circle,rgba(26,26,26,0.05)_1.5px,transparent_1.5px)] [background-size:16px_16px] pointer-events-none" />

        {/* 速度线装饰 */}
        <div className="absolute top-10 left-1/2 -translate-x-1/2 hidden md:flex gap-2 pointer-events-none">
          {[0, 1, 2, 3, 4].map((i) => (
            <span
              key={i}
              className="w-px bg-pink-200/70"
              style={{ height: `${90 + i * 24}px`, transform: `rotate(${(i - 2) * 8}deg)` }}
            />
          ))}
        </div>

        <div className="relative max-w-5xl mx-auto text-center">
          <ScrollReveal>
            {/* 对话气泡式标签 */}
            <div className="flex justify-center mb-7">
              <div className="relative">
                <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border-2 border-gray-900 font-serif text-sm font-bold text-gray-900 shadow-[3px_3px_0_0_#ff9db8]">
                  <i className="ri-flashlight-line text-pink-500" />
                  新番预告
                </span>
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-3 h-3 bg-white border-b-2 border-r-2 border-gray-900 rotate-45" />
              </div>
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight tracking-tight">
              追更日历
              <span className="relative inline-block ml-3">
                不错过每一话
                <span className="absolute -bottom-2 left-0 right-0 h-2 bg-pink-200/80 -rotate-1 rounded-full" />
              </span>
            </h1>

            <p className="mt-7 text-base md:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed">
              天天漫画每日准点上新，提前掌握本周连载节奏，新番首发抢先看，好故事一次追个够。
            </p>
          </ScrollReveal>

          {/* 数据条 */}
          <ScrollReveal delay={120}>
            <div className="mt-12 flex flex-wrap items-center justify-center gap-4 md:gap-6">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="flex items-center gap-3 px-6 py-3.5 rounded-2xl bg-white border-2 border-gray-900 shadow-[4px_4px_0_0_#f9a8d4]"
                >
                  <span className="font-serif text-2xl md:text-3xl font-bold text-gray-900 leading-none">
                    {s.value}
                    {s.unit && <span className="text-base text-pink-500 ml-0.5">{s.unit}</span>}
                  </span>
                  <span className="text-sm text-gray-500 whitespace-nowrap">{s.label}</span>
                </div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* ===== 连载时间轴 ===== */}
      <section className="relative px-4 md:px-8 lg:px-16 xl:px-24 pb-20 md:pb-28">
        <div className="max-w-4xl mx-auto relative">
          {/* 竖向连接线 */}
          <div className="absolute left-[27px] md:left-[43px] top-2 bottom-2 w-0.5 bg-[repeating-linear-gradient(to_bottom,rgba(255,107,138,0.4)_0_8px,transparent_8px_16px)]" />

          <div className="space-y-6 md:space-y-8">
            {days.map((d, i) => {
              return (
                <ScrollReveal key={d.day} delay={i * 50}>
                  <div className="relative flex gap-4 md:gap-8">
                    {/* 日期块 */}
                    <div className="relative z-10 shrink-0 pt-1">
                      <div className="w-[54px] md:w-[86px] rounded-2xl border-2 border-gray-900 overflow-hidden text-center bg-white shadow-[4px_4px_0_0_#ff9db8]">
                        <div className="text-[10px] tracking-[0.2em] pt-2 text-gray-400">
                          {d.en}
                        </div>
                        <div className="font-serif text-xl md:text-2xl font-bold pb-2 text-gray-900">
                          {d.day}
                        </div>
                      </div>
                      {/* 时间戳节点 */}
                      <div className="flex justify-center mt-2">
                        <span className="w-2.5 h-2.5 rounded-full border-2 border-white ring-2 bg-gray-200 ring-gray-100" />
                      </div>
                    </div>

                    {/* 漫画面板 */}
                    <div className="group relative flex-1 rounded-2xl border-2 border-gray-900 bg-white p-5 md:p-7 transition-all duration-300 hover:-translate-y-1 shadow-[6px_6px_0_0_#ffe0e6] hover:shadow-[6px_6px_0_0_#ff9db8]">
                      {/* 网点角标 */}
                      <div className="absolute top-3 right-3 w-16 h-16 bg-[radial-gradient(circle,rgba(255,107,138,0.14)_1.5px,transparent_1.5px)] [background-size:9px_9px] pointer-events-none" />

                      <div className="relative flex flex-wrap items-center gap-3 mb-4 md:mb-5">
                        <span className="inline-flex items-center gap-1.5 text-xs text-gray-500">
                          <i className="ri-time-line text-pink-500" />
                          每日 18:00 更新
                        </span>
                      </div>

                      <div className="relative flex flex-wrap gap-2.5">
                        {d.comics.map((comic) => (
                          <span
                            key={comic.name}
                            className="relative inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-gray-300 text-sm text-gray-800 hover:border-pink-400 hover:text-pink-600 transition-colors cursor-pointer"
                          >
                            <span className="w-1.5 h-1.5 rounded-full bg-pink-400" />
                            {comic.name}
                            {comic.isNew && (
                              <span className="text-[9px] font-bold text-pink-500 -ml-1">NEW</span>
                            )}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </ScrollReveal>
              );
            })}
          </div>
        </div>

        {/* 底部提示 + CTA */}
        <ScrollReveal>
          <div className="max-w-4xl mx-auto mt-14 md:mt-16 text-center">
            <div className="inline-flex items-center gap-3 px-6 py-4 rounded-2xl bg-pink-50/60 border border-pink-100">
              <i className="ri-information-line text-pink-500 text-lg" />
              <p className="text-sm text-gray-500 text-left">
                以上为示例更新计划，实际连载时间以天天漫画APP内作品详情页为准。
              </p>
            </div>
            <div className="mt-8">
              <Link
                to="/download"
                className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-pink-500 text-white text-sm font-medium border-2 border-gray-900 shadow-[5px_5px_0_0_#1a1a1a] hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[3px_3px_0_0_#1a1a1a] transition-all whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg" />
                下载天天漫画，追更不落一话
              </Link>
            </div>
          </div>
        </ScrollReveal>
      </section>
    </div>
  );
}